var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-active-element',{staticClass:"ui-watch-flag",class:{'isSelected': _vm.localIsSelected},attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.toggleIsSelected}},[(_vm.localIsSelected)?_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.WATCHLIST_SELECTED_ITEM}}):_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.WATCHLIST_UNSELECTED_ITEM}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }